import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';
import PropTypes from 'prop-types';

export const PersonaAvatarTwo = memo(
  forwardRef(({ opaque, ...props }, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 72 72"
      data-fill-none
    >
      <path
        d="M72 36.0137C71.9973 43.1332 69.8836 50.0921 65.9262 56.0105C61.9689 61.9289 56.3455 66.5409 49.7671 69.2636C43.1887 71.9862 35.9508 72.6972 28.9684 71.3066C21.9859 69.916 15.5726 66.4862 10.5393 61.451C5.506 56.4157 2.0787 50.0011 0.690743 43.0182C-0.697213 36.0353 0.016507 28.7976 2.74166 22.2202C5.46682 15.6429 10.081 10.0213 16.0009 6.06614C21.9208 2.11102 28.8805 5.16611e-07 36 0C45.5488 0.00436316 54.7051 3.80049 61.4559 10.5538C68.2066 17.3071 71.9993 26.4649 72 36.0137V36.0137Z"
        fill="#8CB2FF"
      />
      <path
        d="M32.1729 12.49C31.1471 12.383 27.0328 12.49 21.9009 17.0184C16.769 21.5469 16.2287 26.5691 16.2287 26.5691C16.2287 26.5691 15.6527 30.527 16.2287 33.6264C16.6605 35.6744 17.3518 37.6588 18.2858 39.5318L20.7544 43.679L19.7944 47.231C19.7944 47.231 17.6577 51.7704 20.0961 55.7201C22.5345 59.6699 26.6789 61.2854 26.6789 61.2854L45.0396 59.7576C45.0396 59.7576 50.4705 58.4987 52.5441 54.7217C54.6177 50.9448 53.5891 47.0692 53.5891 47.0692L52.5962 44.6637L51.5155 43.2511L53.3587 36.5887C53.3587 36.5887 52.9445 34.1586 53.5233 30.5544C54.102 26.9503 54.9249 24.7067 53.8442 21.4591C52.7635 18.2116 51.0904 16.3382 48.7617 14.6815C46.433 13.0248 44.6721 11.722 40.7388 11.0692C36.8056 10.4164 33.3194 11.9359 33.3194 11.9359L32.1729 12.49Z"
        fill="white"
      />
      <path
        d="M53.7476 38.5931C53.7119 39.2267 53.5117 40.5817 52.5846 42.3892C52.3752 42.8205 52.0889 43.2099 51.7398 43.5385C51.5822 43.6819 51.4048 43.802 51.2132 43.8951C50.9447 44.0278 50.6483 44.0939 50.3489 44.0877C50.0495 44.0815 49.7561 44.0032 49.4934 43.8594V43.8594L49.0189 45.3351C48.8433 45.8836 48.6074 46.6132 48.2838 47.6226V47.65C47.8584 48.9439 47.2625 50.1753 46.5119 51.3118C45.9457 52.205 45.2825 53.0329 44.5343 53.7803C44.5343 53.7803 44.5343 53.9038 44.5343 54.1287C44.5151 54.9899 44.4657 57.3323 44.4273 59.7652V59.8201C44.3889 62.1707 44.3642 64.5982 44.3862 65.8544C44.3862 66.1287 44.3862 66.3454 44.4081 66.4935C44.5233 68.2215 46.3281 70.243 46.3281 70.243C39.5613 72.2525 32.3547 72.2401 25.5949 70.2073C25.7809 69.7211 25.9258 69.2201 26.0282 68.7097C26.3155 67.2482 26.5234 65.7722 26.6509 64.2882L26.6893 61.2711L26.7277 58.2868L26.7825 54.1726V53.5856V53.2894L26.6673 53.0151L26.2778 52.1072C25.8699 51.5509 25.5084 50.9619 25.1972 50.3463V50.3271C24.6486 49.2711 24.0836 48.0286 23.6228 46.9369V46.9067C22.9809 45.3899 22.5256 44.1639 22.5256 44.1639C22.3253 44.0529 22.1055 43.9812 21.8783 43.9527L21.7878 43.9335C21.6342 43.9033 21.4504 43.8731 21.2392 43.8457C21.0814 43.8212 20.9319 43.7591 20.8031 43.6647C20.7637 43.64 20.7261 43.6125 20.6906 43.5824C20.2043 43.1045 19.8207 42.5324 19.5633 41.901C19.407 41.5636 19.2589 41.2126 19.1272 40.8642C18.9956 40.5159 18.8529 40.1236 18.7432 39.7918C18.6181 39.3649 18.5753 38.9181 18.617 38.4752C18.7284 37.4043 18.984 36.3535 19.3768 35.3511V35.3511L21.242 35.768C21.316 35.6473 23.7352 31.8046 24.3908 30.3536C24.9777 29.0617 25.3837 26.8866 25.4879 26.3627C25.4879 26.3243 25.5016 26.2859 25.5071 26.2475C25.5126 26.2091 25.5373 26.1653 25.5976 26.0199C26.0903 24.7945 26.7868 23.6612 27.6575 22.6681V22.6681C29.0289 21.2089 30.0164 17.8599 30.0657 17.6953C30.0657 17.6953 31.2397 19.8896 32.26 21.0745C32.6587 21.5041 33.1082 21.8835 33.5985 22.2046C34.9976 23.1045 36.479 23.8695 38.0228 24.4894C38.7578 24.7993 39.6356 25.2437 40.5462 25.7346C42.3702 26.7193 44.3341 27.8987 45.5985 28.5735C45.7933 28.6777 45.9716 28.771 46.1306 28.8478C47.834 29.6706 49.7951 34.6818 50.6591 35.8503C50.9534 36.2331 51.3779 36.4947 51.8522 36.5854C52.3473 36.6861 52.8575 36.6861 53.3526 36.5854L53.4074 36.8158L53.7037 38.0391L53.7421 38.1954C53.7518 38.3278 53.7536 38.4606 53.7476 38.5931V38.5931Z"
        fill="#DEE6F7"
      />
      <path
        d="M30.3013 14.4195C29.5525 15.4206 29.6842 16.8414 30.145 18.0017C31.3546 21.0627 34.3772 22.9992 37.3724 24.3651C40.3676 25.731 43.5932 26.7898 46.0591 28.9703C47.2997 30.0689 48.2991 31.4129 48.9939 32.9173C49.4245 33.8526 49.7482 34.8648 50.4367 35.6328C50.8127 36.0461 51.2784 36.3678 51.7981 36.5732C52.3178 36.7785 52.8776 36.8622 53.4346 36.8177C52.6639 34.681 53.3276 32.3304 53.8021 30.1086C54.4906 26.8748 54.7457 23.3941 53.4456 20.3523C52.3786 17.8563 50.3626 15.8869 48.1957 14.2522C47.0363 13.3387 45.7641 12.5782 44.4106 11.9893C43.0345 11.4421 41.5818 11.1118 40.1043 11.0101C36.8485 10.7496 32.8248 11.0403 30.3013 14.4195Z"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.384 12.5443C30.5354 12.0204 28.5962 12.8624 26.8983 13.7676C24.3009 15.1582 21.7747 16.7847 19.8492 19.0064C17.3093 21.9413 15.9598 25.8306 15.8995 29.7036C15.8602 33.6035 16.9304 37.4342 18.9852 40.749C18.6612 39.85 18.5309 38.8926 18.6028 37.9397C18.6746 36.9868 18.947 36.0598 19.4021 35.2194C19.8794 34.328 20.5459 33.5737 21.1603 32.7509C21.9996 31.6537 22.7402 30.4716 23.478 29.2976L25.9191 25.4192C27.4798 22.9506 29.057 20.4217 29.9018 17.6158"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.4262 30.3438C35.8635 34.2158 35.2059 38.1329 33.5281 41.6498C33.452 41.7816 33.4113 41.931 33.4102 42.0832C33.4387 42.2444 33.5208 42.3913 33.6433 42.5001C33.9799 42.8559 34.3888 43.1355 34.8426 43.3201C35.2963 43.5046 35.7843 43.5897 36.2737 43.5698"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.9805 48.0596C36.8599 48.1801 38.7217 47.6343 40.2385 46.5181C40.4145 46.4103 40.5511 46.2488 40.628 46.0573C40.6437 46.0088 40.6489 45.9576 40.6433 45.907C40.6376 45.8564 40.6213 45.8075 40.5954 45.7637C40.5695 45.7198 40.5345 45.682 40.4928 45.6527C40.4512 45.6234 40.4038 45.6033 40.3537 45.5938C40.5346 45.7078 40.6902 45.8576 40.811 46.034C40.9317 46.2104 41.0151 46.4097 41.0559 46.6196"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.6406 50.8547C36.2002 51.0095 36.7913 51.0088 37.3505 50.8527C37.9097 50.6966 38.4157 50.391 38.8141 49.9688"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.3398 43.9688C42.7019 44.2105 43.0286 44.5013 43.3108 44.8327C43.4525 44.9978 43.5596 45.1898 43.6255 45.3971C43.6915 45.6045 43.7151 45.823 43.6948 46.0396"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.543 38.2109C39.7208 38.6994 39.9836 39.1525 40.3192 39.5495"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.4375 36.8125C54.1945 38.9766 53.5307 41.5522 51.9262 43.1896C51.3922 43.7795 50.6874 44.188 49.9102 44.3581"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.3281 40.0345C50.4122 39.5912 50.6162 39.1795 50.9178 38.8441C51.0732 38.6811 51.2735 38.5681 51.4933 38.5192C51.713 38.4704 51.9424 38.488 52.1521 38.5698"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.7909 43.5078C54.0839 46.3138 54.5337 50.2882 53.1102 53.6262C51.6866 56.9643 48.0002 59.452 44.3906 59.762"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.2907 44.6641C20.2213 45.9921 19.498 47.5647 19.1859 49.2409C18.8737 50.9172 18.9824 52.6447 19.5021 54.2687C20.0219 55.8926 20.9365 57.3622 22.1639 58.5457C23.3913 59.7292 24.8933 60.5896 26.5351 61.0499"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.6874 52.6875C26.5119 55.3755 26.8081 59.2539 26.8191 61.9474C26.83 64.6409 26.6079 67.3892 25.582 69.8825"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.4279 54.2188C44.3182 57.4059 44.1262 61.0539 44.2524 64.2411C44.2589 65.2451 44.3878 66.2445 44.6364 67.2171C44.951 68.2907 45.5236 69.271 46.304 70.0725"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6953 39.6719C18.961 41.041 19.6185 42.3035 20.5879 43.3062C20.9006 43.6463 22.0608 44.0961 22.5079 44.1811"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5469 35.3677C19.8431 35.3814 20.9018 35.4719 21.3023 35.8367C22.6573 33.8564 23.7434 32.441 24.5498 30.1809C24.9821 28.9006 25.2898 27.5816 25.4687 26.2422"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4102 38.209C20.4003 38.1157 21.5304 39.1553 21.6044 39.9178"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.3372 31.8581C27.7369 30.6372 29.4833 29.8844 31.3319 29.7049C31.4444 29.7049 31.5733 29.6747 31.6281 29.5787C31.6562 29.5209 31.6667 29.456 31.6583 29.3922C31.6407 29.1323 31.5737 28.8782 31.4608 28.6434C31.413 28.5267 31.3331 28.426 31.2304 28.3527C31.0437 28.2681 30.8317 28.2582 30.638 28.3253C28.9923 28.6873 27.267 29.3538 26.3454 30.7691C26.1287 31.0955 25.9587 31.4905 26.3372 31.8581Z"
        fill="black"
      />
      <path
        d="M32.3711 27.9609C32.4894 28.5517 32.5519 29.1523 32.5576 29.7548"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.682 31.8581C43.2822 30.6372 41.5359 29.8844 39.6872 29.7049C39.6315 29.7077 39.5759 29.6979 39.5246 29.676C39.4733 29.6541 39.4276 29.6209 39.391 29.5787C39.3626 29.521 39.353 29.4557 39.3636 29.3922C39.379 29.1323 39.4452 28.8779 39.5583 28.6434C39.6072 28.5265 39.688 28.4258 39.7915 28.3527C39.9782 28.2681 40.1902 28.2582 40.3839 28.3253C42.0296 28.6873 43.7549 29.3538 44.6765 30.7691C44.8932 31.0955 45.0605 31.4905 44.682 31.8581Z"
        fill="black"
      />
      <path
        d="M38.6502 27.9609C38.5296 28.5514 38.4662 29.1521 38.4609 29.7548"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.6665 36.0152C49.9972 48.6324 44.0617 58.3777 36.25 58.3777C28.4384 58.3777 21.9872 48.4267 21.3398 35.7656"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.0905 37.9901C43.5525 37.9901 43.9271 37.1808 43.9271 36.1825C43.9271 35.1843 43.5525 34.375 43.0905 34.375C42.6285 34.375 42.2539 35.1843 42.2539 36.1825C42.2539 37.1808 42.6285 37.9901 43.0905 37.9901Z"
        fill="black"
      />
      <path
        d="M27.6217 37.9901C28.0838 37.9901 28.4583 37.1808 28.4583 36.1825C28.4583 35.1843 28.0838 34.375 27.6217 34.375C27.1597 34.375 26.7852 35.1843 26.7852 36.1825C26.7852 37.1808 27.1597 37.9901 27.6217 37.9901Z"
        fill="black"
      />
      <path
        d="M20.9038 46.3077C21.6597 46.3077 22.2725 45.6949 22.2725 44.939C22.2725 44.1831 21.6597 43.5703 20.9038 43.5703C20.1479 43.5703 19.5352 44.1831 19.5352 44.939C19.5352 45.6949 20.1479 46.3077 20.9038 46.3077Z"
        fill="black"
      />
      <path
        d="M50.3296 46.3077C51.0855 46.3077 51.6983 45.6949 51.6983 44.939C51.6983 44.1831 51.0855 43.5703 50.3296 43.5703C49.5737 43.5703 48.9609 44.1831 48.9609 44.939C48.9609 45.6949 49.5737 46.3077 50.3296 46.3077Z"
        fill="black"
      />
      <path
        d="M30.1133 39.9096C30.1133 39.9096 31.3201 39.0401 31.6575 38.1953"
        stroke="black"
        strokeWidth="0.549618"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.6484 53.8454C26.6484 53.8454 29.4269 62.074 36.0071 62.1618C42.5872 62.2496 44.2027 56.207 44.2027 56.207L44.093 54.586C44.093 54.586 40.7604 58.5769 35.8809 58.3657C31.0014 58.1545 26.9639 53.2969 26.9639 53.2969L26.6484 53.8454Z"
        fill="black"
      />
    </SvgIcon>
  ))
);

PersonaAvatarTwo.propTypes = {
  opaque: PropTypes.bool,
};
PersonaAvatarTwo.defaultProps = {
  opaque: false,
};
